import { render, staticRenderFns } from "./CardFormEdit.vue?vue&type=template&id=50d8caab&"
import script from "./CardFormEdit.vue?vue&type=script&lang=js&"
export * from "./CardFormEdit.vue?vue&type=script&lang=js&"
import style0 from "./CardFormEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports